<template>
<!-- ESTE ARCHIVO SE VA A BOORAR Y REEMPLAZAR POR LMFEATURESBUILDER -->
  <main class="wrapper-content">
    <h1>Aca voy a construir el generador de rutas del frontend</h1>
    <LmBreadcrumb />
    <div>
    <b-card no-body v-if="myRoutes">
      <b-tabs pills card vertical>
        <b-tab
          v-for="(route, index) of myRoutes"
          :key="route._id"
          :title="route.path"
        >
          <b-card-text>
            <h5>{{ route.name }}</h5>

            <LmTreeSelect
              label="Privilegios que tendrán acceso"
              multiple
              :options="privilegesOptions"
              :value="privilegeValues[index].privileges"
              @input="onChangePrivileges($event, index)"
            />
            <LmButton
              value="Guardar"
              @click="onSave(route)"
            />
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
  </main>
</template>

<script>
// Components
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmButton from '@/components/form/elements/LmButton'

// Utils
import commonsApi from '@/api/commons'
import _ from 'lodash'

export default {
  data () {
    return {
      myRoutes: null,
      privilegesOptions: null
    }
  },
  computed: {
    privilegeValues () {
      const values = []
      const myRoutes = _.cloneDeep(this.myRoutes)
      myRoutes.forEach(route => {
        if (route?.privileges) {
          route.privileges = route.privileges.map(priv => {
            return this.privilegesOptions.find(option => option.codigo_privilegio === priv)
          })
        }
        values.push(route)
      })
      return values
    }
  },
  components: {
    LmTreeSelect,
    LmButton
  },
  methods: {
    async onSave (route) {
      try {
        console.log(route)
        await commonsApi.axiosPutWrapper(`/frontendroutes/${route._id}`, {
          privileges: route.privileges
        })
      } catch (error) {
        console.log(error)
      }
    },
    onChangePrivileges (event, index) {
      this.myRoutes[index].privileges = event.map(e => e.codigo_privilegio)
      console.log(this.myRoutes)
    }
  },
  async created () {
    try {
      const privileges = await commonsApi.axiosGetWrapper('/codificatorbuilder/codificators/60ef50e476b81943ec4d99da')
      this.privilegesOptions = privileges.data.items

      const myRotues = await commonsApi.axiosGetWrapper('/frontendroutes/myroutes')
      this.myRoutes = myRotues.data
    } catch (error) {
      console.log(error)
    }
  }
}
</script>
